"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoundsOfCurve = void 0;
const getBoundsOfCurve = (p0, p1, p2, p3) => {
    const x0 = p0.x;
    const y0 = p0.y;
    const x1 = p1.x;
    const y1 = p1.y;
    const x2 = p2.x;
    const y2 = p2.y;
    const x3 = p3.x;
    const y3 = p3.y;
    const tvalues = [];
    const bounds = [[], []];
    const points = [];
    let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
    for (let i = 0; i < 2; ++i) {
        if (i === 0) {
            b = 6 * x0 - 12 * x1 + 6 * x2;
            a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
            c = 3 * x1 - 3 * x0;
        }
        else {
            b = 6 * y0 - 12 * y1 + 6 * y2;
            a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
            c = 3 * y1 - 3 * y0;
        }
        if (Math.abs(a) < 1e-12) {
            // Numerical robustness
            if (Math.abs(b) < 1e-12) {
                // Numerical robustness
                continue;
            }
            t = -c / b;
            if (t > 0 && t < 1) {
                tvalues.push(t);
            }
            continue;
        }
        b2ac = b * b - 4 * c * a;
        sqrtb2ac = Math.sqrt(b2ac);
        if (b2ac < 0) {
            continue;
        }
        t1 = (-b + sqrtb2ac) / (2 * a);
        if (t1 > 0 && t1 < 1) {
            tvalues.push(t1);
        }
        t2 = (-b - sqrtb2ac) / (2 * a);
        if (t2 > 0 && t2 < 1) {
            tvalues.push(t2);
        }
    }
    let x;
    let y;
    let j = tvalues.length;
    let mt;
    const jlen = j;
    while (j--) {
        t = tvalues[j];
        mt = 1 - t;
        x = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
        bounds[0][j] = x;
        y = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
        bounds[1][j] = y;
        points[j] = {
            X: x,
            Y: y,
        };
    }
    tvalues[jlen] = 0;
    tvalues[jlen + 1] = 1;
    points[jlen] = {
        X: x0,
        Y: y0,
    };
    points[jlen + 1] = {
        X: x3,
        Y: y3,
    };
    bounds[0][jlen] = x0;
    bounds[1][jlen] = y0;
    bounds[0][jlen + 1] = x3;
    bounds[1][jlen + 1] = y3;
    tvalues.length = bounds[0].length = bounds[1].length = points.length = jlen + 2;
    return {
        left: Math.min.apply(null, bounds[0]),
        top: Math.min.apply(null, bounds[1]),
        right: Math.max.apply(null, bounds[0]),
        bottom: Math.max.apply(null, bounds[1]),
    };
};
exports.getBoundsOfCurve = getBoundsOfCurve;
//# sourceMappingURL=utility.curve.js.map